// import React, { useState } from "react";
// import { Button } from "common/components";
// import { Box, Card, Typography, Select, MenuItem } from "@mui/material";
// import { ReadMoreOutlined } from "@mui/icons-material";
// import { useNavigate } from "react-router-dom";

// const DOC_TYPES = [
//   { key: "jib", label: "JIB" },
//   { key: "invoice", label: "Invoice" },
//   { key: "aef", label: "AEF" },
//   { key: "permit", label: "Permit" },
//   { key: "pid", label: "PID" },
//   { key: "contract", label: "Contract" }
// ];

// const DocumentParser = () => {
//   const navigate = useNavigate();
//   const [selectedType, setSelectedType] = useState(DOC_TYPES[0].key);

//   return (
//     <div>
//       <Button
//         variant="text"
//         onClick={() => navigate(-1)}
//         style={{ marginBottom: "20px" }}
//       >
//         &larr; Back
//       </Button>
//       <h1 style={{ textAlign: "center" }}>Document Parser</h1>
//       <h5 style={{ marginTop: "20px" }}>
//         Select the document type to be parsed
//       </h5>
//       <Box width="50%" marginTop={2}>
//         <Card
//           variant="outlined"
//           sx={{
//             backgroundColor: "transparent",
//             color: "#ffffff",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             flexDirection: "column",
//             padding: 4,
//             border: "1px solid #ffffff"
//           }}
//         >
//           <Typography sx={{ mb: 2 }}>Select Document Type</Typography>
//           <Select
//             variant="outlined"
//             value={selectedType}
//             onChange={(e) => setSelectedType(e.target.value)}
//             sx={{ width: 230, mb: 4, backgroundColor: "#fff", color: "#000" }}
//           >
//             {DOC_TYPES.map((type) => (
//               <MenuItem key={type.key} value={type.key}>
//                 {type.label}
//               </MenuItem>
//             ))}
//           </Select>
//           <Button
//             onClick={() => navigate(`/bulk-upload/${selectedType}`)}
//            variant="primary-alt"
//             startIcon={<ReadMoreOutlined />}
//             className="document-list__upload-button"
//             iconClassName="document-list__upload-icon-button"
//           >
//             Parse Document
//           </Button>
//         </Card>
//       </Box>
//     </div>
//   );
// };

// export default DocumentParser;

// import React, { useState } from "react";
// import { Button } from "common/components";
// import { Box, Card, Typography, Select, MenuItem, FormControl, InputLabel, Divider } from "@mui/material";
// import { ReadMoreOutlined } from "@mui/icons-material";
// import { useNavigate } from "react-router-dom";

// const DOC_TYPES = [
//   { key: "jib", label: "JIB" },
//   { key: "invoice", label: "Invoice" },
//   { key: "aef", label: "AEF" },
//   { key: "permit", label: "Permit" },
//   { key: "pid", label: "PID" },
//   { key: "contract", label: "Contract" }
// ];

// // Modern, clear, business-aligned professional UI
// const DocumentParser = () => {
//   const navigate = useNavigate();
//   const [selectedType, setSelectedType] = useState(DOC_TYPES[0].key);

//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center",
//         pt: 7,
//         background: "transparent",
//         color: "#ffffff"
//       }}
//     >
//       <Box sx={{ width: "50%", maxWidth: 470 }}>
//         <Button
//           variant="text"
//           onClick={() => navigate(-1)}
//           style={{
//             marginBottom: "24px",
//             textTransform: "none",
//             fontWeight: 500,
//             fontSize: "1rem"
//           }}
//         >
//           &larr; Back
//         </Button>
//         <Card
//           variant="outlined"
//           sx={{
//             backgroundColor: "transparent",
//             borderRadius: "14px",
//             border: "1px solid #e0e0e0",
//             boxShadow: "0 4px 18px 0 rgba(0,0,0,0.14)",
//             p: 4,
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             gap: 3
//           }}
//         >
//           <Typography
//             sx={{
//               fontWeight: 600,
//               fontSize: "2rem",
//               letterSpacing: "1px",
//               color: "#fff",
//               mb: 0.5
//             }}
//           >
//             Document Parser
//           </Typography>
//           <Typography
//             sx={{
//               fontWeight: 400,
//               fontSize: "1.09rem",
//               color: "#aaaaaa"
//             }}
//           >
//             Select the document type to be parsed.
//           </Typography>
//           <Divider sx={{ width: "100%", my: 2, bgcolor: "#444" }} />
//            <InputLabel sx={{ color: "#fff", marginBottom:"2px" }}>Document Type</InputLabel>
//           <FormControl variant="outlined" fullWidth sx={{ mb: 2 }}>

//             <Select
//               value={selectedType}

//               onChange={(e) => setSelectedType(e.target.value)}
//               sx={{
//                 backgroundColor: "#fff",
//                 color: "#222",
//                 borderRadius: 2,
//                 fontWeight: 500
//               }}
//             >
//               {DOC_TYPES.map((type) => (
//                 <MenuItem key={type.key} value={type.key}>
//                   {type.label}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//           <Button
//             onClick={() => navigate(`/bulk-upload/${selectedType}`)}
//             startIcon={<ReadMoreOutlined />}
//             variant="primary-alt"
//             style={{
//               width: "100%",
//               // py: 1.2,
//               borderRadius: 2,
//               fontWeight: 500,
//               boxShadow: "0 2px 8px 0 rgba(0,0,0,0.12)"
//             }}
//           >
//             Parse Document
//           </Button>
//         </Card>
//       </Box>
//     </Box>
//   );
// };

// export default DocumentParser;

import React, { useState } from "react";
import { Button } from "common/components";
import {
  Box,
  Card,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Divider
} from "@mui/material";
import { ReadMoreOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const DOC_TYPES = [
  { key: "jib", label: "JIB" },
  // { key: "invoice", label: "Invoice" },
  // { key: "aef", label: "AEF" },
  // { key: "permit", label: "Permit" },
  // { key: "pid", label: "PID" },
  { key: "contract", label: "Contract" }
];

const DocumentParser = () => {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState(DOC_TYPES[0].key);

  return (
    <>
      <Button
        variant="text"
        onClick={() => navigate(-1)}
        style={{
          marginBottom: "24px",
          textTransform: "none",
          fontWeight: 500,
          fontSize: "1rem"
        }}
      >
        &larr; Back
      </Button>

      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start", // Left top align everything
          pt: 7,
          pl: 6,
          background: "transparent",
          color: "#ffffff"
        }}
      >
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "2rem",
            letterSpacing: "1px",
            color: "#fff",
            mb: 0.5,
            textAlign: "left"
          }}
        >
          Document Parser
        </Typography>
        <Card
          variant="outlined"
          sx={{
            backgroundColor: "transparent",
            borderRadius: "14px",
            border: "1px solid #e0e0e0",
            boxShadow: "0 4px 18px 0 rgba(0,0,0,0.14)",
            p: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: 2,
            width: 1000
          }}
        >
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: "1.09rem",
              color: "#aaaaaa",
              mb: 2,
              textAlign: "left"
            }}
          >
            Select the document type to be parsed.
          </Typography>

          <Divider sx={{ width: "100%", my: 2, bgcolor: "#444" }} />

          <InputLabel sx={{ color: "#fff", mb: 1 }}>Document Type</InputLabel>
          <FormControl variant="outlined" sx={{ mb: 2 }}>
            <Select
              value={selectedType}
              onChange={(e) => setSelectedType(e.target.value)}
              sx={{
                backgroundColor: "#fff",
                color: "#222",
                borderRadius: 2,
                fontWeight: 500,
                width: "600px"
              }}
            >
              {DOC_TYPES.map((type) => (
                <MenuItem key={type.key} value={type.key}>
                  {type.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button
            onClick={() => navigate(`/bulk-upload/${selectedType}`)}
            startIcon={<ReadMoreOutlined />}
            variant="primary-alt"
            style={{
              alignSelf: "flex-start", // Button left-align
              borderRadius: 2,
              fontWeight: 500,
              boxShadow: "0 2px 8px 0 rgba(0,0,0,0.12)"
            }}
          >
            Parse Document
          </Button>
        </Card>
      </Box>
    </>
  );
};

export default DocumentParser;
